module.exports = new __parcel__URL__("motomami.f4c4f716.jpg").toString();